module.exports = __webpack_public_path__ + "img/mbBanner17.6216ce42.png";